import { Injectable } from '@angular/core';
import { CanActivate, CanLoad, Route, UrlSegment, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { SessionService } from '../services/session.service';
import { AppRoutes } from '@ciptech/constants'

@Injectable()
export class AuthenticatedGuard implements CanActivate, CanLoad {

	constructor(
		private session: SessionService,
		private router: Router
	) { }

	private checkGuest(): boolean | UrlTree {
		const user = this.session.user;
		if (user && user?.isAuthenticated()) {
			return this.router.createUrlTree([AppRoutes.PROFILE]);
		}
		return true;
	}

	private checkAuth(returnUrl?: string): boolean | UrlTree {
		if (!this.session.token) {
			return this.router.createUrlTree([AppRoutes.SIGN_IN], {
				queryParams: returnUrl ? { returnUrl } : undefined
			});
		}
		return true;
	}

	canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree {
		const requiresGuest = next.data?.['guestOnly'];
		if (requiresGuest) {
			return this.checkGuest();
		}
		return this.checkAuth(state.url);
	}

	canLoad(route: Route, segments: UrlSegment[]): boolean | UrlTree {
		const requiresGuest = route.data?.['guestOnly'];

		if (requiresGuest) {
			return this.checkGuest();
		}

		const url = '/' + segments.map(s => s.path).join('/');
		return this.checkAuth(url);
	}

}
